import React from 'react';
import { Link } from 'react-router-dom';
import StackBadges from './StackBadges';

function ProjectCard({ project, compact = false }) {
  const preview = project.screenshots?.[0];
  const isSample = project.screenshotLayout === 'samples';

  if (compact) {
    return (
      <div className="project-card project-card-compact">
        <span className={`project-badge project-badge-${project.statusVariant}`}>
          {project.status}
        </span>
        <div className="project-card-content">
          <p className="project-category">{project.category}</p>
          <h3 className="project-name">{project.title}</h3>
          <p className="project-description">{project.description}</p>
        </div>
        <div className="project-card-footer">
          <Link className="project-view-btn project-view-btn-quiet" to={`/projects/${project.slug}`}>
            <span>View project</span>
            <span className="project-view-arrow" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={`project-card${preview ? ' project-card-has-preview' : ''}`}>
      <span className={`project-badge project-badge-${project.statusVariant}`}>
        {project.status}
      </span>

      <div className="project-card-body">
        <div className="project-card-content">
          <div className="project-card-title-row">
            {project.icon && (
              <img
                className="project-app-icon project-app-icon-sm"
                src={project.icon}
                alt=""
                width={40}
                height={40}
              />
            )}
            <div>
              <p className="project-category">{project.category}</p>
              <h3 className="project-name">{project.title}</h3>
            </div>
          </div>
          <p className="project-description">{project.description}</p>
          {project.hardPart && <p className="project-hard-part">{project.hardPart}</p>}
          <StackBadges items={project.stack} />
        </div>

        {preview && (
          <div className="project-card-preview" aria-hidden="true">
            <div
              className={`project-shot project-shot-card${
                isSample ? ' project-shot-sample' : ''
              }`}
            >
              <img src={preview} alt="" width={120} height={isSample ? 120 : 260} loading="lazy" />
            </div>
          </div>
        )}
      </div>

      <div className="project-card-footer">
        <Link className="project-view-btn" to={`/projects/${project.slug}`}>
          <span>View project</span>
          <span className="project-view-arrow" aria-hidden="true">
            →
          </span>
        </Link>
      </div>
    </div>
  );
}

export default ProjectCard;
